export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Affiché:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["total"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Par page"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Afficher"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Résultats"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["sur"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Échange"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Échanges"])}
}